import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigurationService } from './core/config/configuration.service';
import { CoreModule } from './core/core.module';
import { MainAdminComponent } from './features/admin/main-admin/main-admin.component';
import { MainGroupComponent } from './features/group/main-group/main-group.component';
import { MainPracticeComponent } from './features/practice/main-practice/main-practice.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
    declarations: [
        AppComponent,
        // Main
        MainAdminComponent,
        MainGroupComponent,
        MainPracticeComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        // ADDLims
        AppRoutingModule,
        CoreModule,
        SharedModule,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [ConfigurationService],
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}

export function initializeApp(configurationService: ConfigurationService) {
    return () => {
        const initializerPromise = configurationService.load();

        initializerPromise.catch(() => {
            alert('Application could not be started.');
        });
        return initializerPromise;
    };
}
